import { BaseModel } from './base.model';

export abstract class BaseEntityModel extends BaseModel {
    id: any = '';

    protected constructor(init?: Partial<BaseEntityModel>) {
        super();
        Object.assign(this, init);
    }
}
